import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#8B0000', // Deep Blood Red
            light: '#B22222',
            dark: '#580000',
            contrastText: '#FFD700',
        },
        secondary: {
            main: '#FFD700', // Metallic Gold
            light: '#FFEC8B',
            dark: '#B8860B',
            contrastText: '#000000',
        },
        background: {
            default: '#000000',
            paper: '#121212', // Slightly lighter black for cards
        },
        text: {
            primary: '#FFFFFF',
            secondary: '#FFD700', // Gold for secondary text/highlights
        },
    },
    typography: {
        fontFamily: "'Montserrat', 'Roboto', 'Helvetica', 'Arial', sans-serif",
        h1: {
            fontWeight: 700,
            fontSize: '3rem',
            textTransform: 'uppercase',
            letterSpacing: '0.1em',
            background: 'linear-gradient(45deg, #FFD700, #B8860B)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
        },
        h2: {
            fontWeight: 600,
            fontSize: '2.5rem',
            color: '#FFD700',
        },
        h3: {
            fontWeight: 600,
            fontSize: '2rem',
        },
        button: {
            fontWeight: 600,
            letterSpacing: '0.05em',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '50px',
                    padding: '10px 30px',
                    background: 'linear-gradient(45deg, #8B0000 30%, #FFD700 90%)',
                    color: '#000',
                    transition: 'transform 0.2s',
                    '&:hover': {
                        transform: 'scale(1.05)',
                        boxShadow: '0 0 15px rgba(255, 215, 0, 0.5)',
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none', // Remove default overlay in dark mode
                    background: 'rgba(20, 20, 20, 0.8)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 215, 0, 0.1)',
                },
            },
        },
    },
});

export default theme;
